import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');
      
      if (!sessionId) {
        navigate('/login');
        return;
      }

      // Retrieve stored portal and event code
      const portal = sessionStorage.getItem('google_auth_portal') || 'attendee';
      const eventCode = sessionStorage.getItem('google_auth_event_code') || '';

      try {
        const response = await axios.post(`${API_URL}/api/auth/google/callback`, {
          session_id: sessionId,
          portal,
          event_code: eventCode || undefined
        });

        const { token, user, event } = response.data;

        // Store auth data (same as regular login)
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        if (event) {
          localStorage.setItem('eventInfo', JSON.stringify(event));
        }

        // Clean up
        sessionStorage.removeItem('google_auth_portal');
        sessionStorage.removeItem('google_auth_event_code');

        // Redirect based on portal
        if (portal === 'admin') {
          navigate('/admin', { replace: true });
        } else if (portal === 'organizer') {
          navigate('/organizer', { replace: true });
        } else {
          navigate('/attendee', { replace: true });
        }

        // Force page reload to initialize auth context properly
        window.location.reload();
      } catch (error) {
        const detail = error.response?.data?.detail || 'Google sign-in failed';
        sessionStorage.setItem('google_auth_error', detail);
        
        if (portal === 'admin') {
          navigate('/admin/login', { replace: true });
        } else if (portal === 'organizer') {
          navigate('/login', { replace: true });
        } else {
          navigate('/attendee/login', { replace: true });
        }
      }
    };

    processAuth();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-cream-paper flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-10 w-10 animate-spin text-maroon mx-auto mb-4" />
        <p className="text-gray-600 font-medium">Signing in with Google...</p>
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
